export default __webpack_public_path__ + "images/sh-c5ab8c6e3ffc963e14fb32d4ac271ccd.svg";